export default ".muted {\n  font-weight: 500;\n  font-size: 1.1rem;\n  color: var(--muted-color);\n  white-space: nowrap;\n}";